export default {
  GOOGLE_GEOCODING_BASE_URL: 'https://maps.googleapis.com/maps/api/geocode/json?address=',
  GOOGLE_GEOCODING_API_KEY: 'AIzaSyC4R9aVocwhuhFvyDGBltGAnoU4mfb-xxA',
  MAPBOX_ACCESS_TOKEN: 'pk.eyJ1IjoiaHVnb2J1cmJlbG8iLCJhIjoiY2swMTZwOHZlMjM2djNucDBzMDNqMG11ZCJ9.29ZXkabatNiDMjQgkhkq3A',
  MAPBOX_ZOOM: 12,
  MAPBOX_STYLE: 'mapbox://styles/mapbox/light-v10'
}
